import React from 'react';
import { Link } from 'react-router-dom';
import { IconImages, IconArrowRight, IconGrid } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './PortfolioTeaser.css';

const PortfolioTeaser = () => {
  const { t, toPath } = useLanguage();
  const previewImages = [
    { src: '/img/Bildpakete/Alpinspirit x/Promo.webp', alt: 'Alpinspirit Product Design' },
    { src: '/img/Bildpakete/Aquaone x/Promo.webp', alt: 'Aquaone Product Design' },
    { src: '/img/Bildpakete/Boomding x/promo.webp', alt: 'Boomding Product Design' },
    { src: '/img/Bildpakete/Graefenhof x/Promo.webp', alt: 'Gräfenhof Product Design' },
    { src: '/img/Bildpakete/McFilter x/Promo.webp', alt: 'McFilter Product Design' },
    { src: '/img/Bildpakete/Yosana x/Promo.webp', alt: 'Yosana Product Design' },
  ];

  const textReveal = useScrollReveal({ threshold: 0.15 });
  const previewReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="portfolio-teaser-fox" id="gallery">
      <div className="portfolio-teaser-fox__bg-glow"></div>
      <div className="portfolio-teaser-fox__container">
        <div className="portfolio-teaser-fox__content">
          <div ref={textReveal.ref} className={`portfolio-teaser-fox__text reveal--left ${textReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="portfolio-teaser-fox__label">
              <IconImages size={22} />
              {t.portfolioTeaser.label}
            </div>
            <h2 className="portfolio-teaser-fox__title">
              {t.portfolioTeaser.title} <br/> <span className="portfolio-teaser-fox__title-gradient">{t.portfolioTeaser.titleHighlight}</span>
            </h2>
            <p className="portfolio-teaser-fox__subtitle">{t.portfolioTeaser.subtitle}</p>
            <Link to={toPath('/portfolio')} className="portfolio-teaser-fox__cta">
              <span>{t.portfolioTeaser.ctaLink}</span>
              <span className="portfolio-teaser-fox__cta-icon"><IconArrowRight size={16} /></span>
            </Link>
          </div>
          <div ref={previewReveal.ref} className={`portfolio-teaser-fox__preview reveal--right ${previewReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="portfolio-teaser-fox__preview-grid">
              {previewImages.map((img, index) => (
                <div key={index} className="portfolio-teaser-fox__preview-item">
                  <img src={img.src} alt={img.alt} width={200} height={200} loading="lazy" decoding="async" />
                </div>
              ))}
            </div>
            <div className="portfolio-teaser-fox__preview-overlay">
              <Link to={toPath('/portfolio')} className="portfolio-teaser-fox__preview-link">
                <IconGrid size={18} />
                <span>{t.portfolioTeaser.viewAll}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioTeaser;
